<template>
  <editor :value="value" :init="init" @input="$emit('input', $event)" />
</template>

<script>
// TinyMCE is bundled by webpack, so nothing has to be copied into /public or loaded
// from a CDN. Required packages (once):  npm i tinymce@5.10.9 @tinymce/tinymce-vue@3
import "tinymce/tinymce"; // core, also sets the global the Vue wrapper looks for
import "tinymce/icons/default";
import "tinymce/themes/silver";
import "tinymce/plugins/table";
import "tinymce/plugins/lists";
import "tinymce/plugins/link";
import "tinymce/plugins/image";
import "tinymce/plugins/code";
import "tinymce/skins/ui/oxide/skin.min.css"; // editor UI (toolbar, dialogs)
import Editor from "@tinymce/tinymce-vue";

// Styles used inside the editing area (the editor iframe).
const CONTENT_STYLE = `
  body { font-family: Helvetica, Arial, sans-serif; font-size: 15px; line-height: 1.6; margin: 12px; }
  img { max-width: 100%; height: auto; }
  table { border-collapse: collapse; width: 100%; }
  th, td { border: 1px solid #ccc; padding: 8px; }
  th { background: #3f5bdc; color: #fff; text-align: left; }
  .callout { background: #12263f; color: #fff; border-left: 5px solid #f59e0b;
             padding: 12px 16px; border-radius: 0 12px 12px 0; margin: 16px 0; }
  .callout-tip { border-left-color: #22c55e; }
  .callout-warn { border-left-color: #ef4444; }
`;

export default {
  name: "RichEditor",
  components: { Editor },
  props: {
    value: { type: String, default: "" },
    height: { type: Number, default: 520 },
  },
  data() {
    return {
      init: {
        height: this.height,
        menubar: false,
        branding: false,
        // The skin and content CSS are imported above, so TinyMCE must not try to
        // fetch them from a /skins folder at runtime.
        skin: false,
        content_css: false,
        plugins: "table lists link image code",
        toolbar:
          "undo redo | styleselect | bold italic underline | bullist numlist | table | link image | removeformat code",
        style_formats: [
          { title: "Paragraph", block: "p" },
          { title: "Heading 2", block: "h2" },
          { title: "Heading 3", block: "h3" },
          {
            title: "Cards",
            items: [
              {
                title: "Hoops trivia card",
                block: "div",
                classes: "callout callout-trivia",
                wrapper: true,
              },
              {
                title: "Tip card",
                block: "div",
                classes: "callout callout-tip",
                wrapper: true,
              },
              {
                title: "Warning card",
                block: "div",
                classes: "callout callout-warn",
                wrapper: true,
              },
            ],
          },
        ],
        content_style: CONTENT_STYLE,
        convert_urls: false,
        relative_urls: false,
        automatic_uploads: true,
        paste_data_images: true,
        images_upload_handler: (blobInfo, success, failure) => {
          this.$store
            .dispatch("blogs/uploadFile", {
              file: blobInfo.blob(),
              name: blobInfo.filename(),
            })
            .then((uploaded) => {
              if (uploaded) {
                success(uploaded.url);
              } else {
                failure(
                  this.$store.state.blogs.errors.file || "Image upload failed.",
                );
              }
            });
        },
      },
    };
  },
};
</script>
